import { useI18n } from "@/i18n/I18nProvider";

export default function CTA() {
    const { t } = useI18n();
    const c = t.cta;
    return (
        <section
            id="cta"
            data-testid="cta-section"
            className="relative py-28 md:py-40 border-t border-white/5 overflow-hidden"
        >
            <div className="absolute inset-0 court-bg opacity-50" aria-hidden />
            <div
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[1100px] h-[1100px] rounded-full pointer-events-none"
                style={{
                    background:
                        "radial-gradient(closest-side, rgba(212,255,0,0.15), transparent 70%)",
                }}
                aria-hidden
            />
            <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 text-center">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-[#D4FF00]/30 text-[#D4FF00] text-[11px] tracking-widest uppercase font-bold mb-6">
                    {c.eyebrow}
                </div>
                <h2 className="font-display font-bold uppercase text-5xl sm:text-6xl md:text-7xl lg:text-[120px] tracking-tighter heading-clamp">
                    {c.headlinePart1}{" "}
                    <span className="text-[#D4FF00] lime-text-glow">
                        {c.headlineAccent}
                    </span>{" "}
                    {c.headlinePart2}
                </h2>
                <p className="mt-8 text-lg md:text-xl text-white/65 max-w-2xl mx-auto leading-relaxed">
                    {c.sub}
                </p>
                <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
                    <a
                        href="#pricing"
                        data-testid="cta-primary"
                        className="inline-flex items-center gap-2 px-7 py-4 rounded-full bg-[#D4FF00] hover:bg-[#BDF000] text-[#04140D] font-bold text-base tracking-tight transition-all hover:scale-[1.03] active:scale-[0.98] lime-glow"
                    >
                        {c.primary}
                        <span aria-hidden>→</span>
                    </a>
                    <a
                        href="mailto:hello@davini.ai"
                        data-testid="cta-secondary"
                        className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-white/15 hover:border-white/40 hover:bg-white/[0.03] text-white font-semibold transition-all"
                    >
                        {c.secondary}
                    </a>
                </div>
                <div className="mt-10 text-xs text-white/40 uppercase tracking-widest font-semibold">
                    {c.footnote}
                </div>
            </div>
        </section>
    );
}
